module.exports = __webpack_public_path__ + "sk-rv-complete-mockup@2x.39MUlxJ0.png";